import AgentLoginAction from './AgentLoginAction';
import AgentLogoffAction from './AgentLogoffAction';
import AgentWhatsAppLoginAction from './AgentWhatsAppLoginAction';
import PongBrokerAction from './PongBrokerAction';
import PongChatvisorBrokerAction from './PongChatvisorBrokerAction';

export default class CallAction {
  constructor() {
    return this;
  }

  static login(user, password) {
    return new AgentLoginAction(user, password);
  }

  static logoff(agentId) {
    return new AgentLogoffAction(agentId);
  }

  static connectWhatsApp(agentId) {
    return new AgentWhatsAppLoginAction(agentId);
  }

  static sendPongBroker(agentId) {
    return new PongBrokerAction(agentId);
  }

  static sendPongChatvisorBrokerAction(agentId) {
    return new PongChatvisorBrokerAction(agentId);
  }
}
